import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {LoadingService} from "../util/service/loading.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {inject, PLATFORM_ID} from "@angular/core";
import {TooManyRequestOptions} from "../module/dialog/too-many-request/options/too-many-request.options";
import {TooManyRequestComponent} from "../module/dialog/too-many-request/too-many-request.component";
import {MaintenanceOptions} from "../module/dialog/maintenance/options/maintenance.options";
import {MaintenanceComponent} from "../module/dialog/maintenance/maintenance.component";
import {RouteUtil} from "../util/route.util";
import {isPlatformServer} from "@angular/common";
import {WindowUtil} from "../util/window.util";

export const LoadingInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  if (req.url.includes('/i18n/') || req.url.includes('silent=true') || isPlatformServer(inject(PLATFORM_ID))) {
    return next(req).pipe(
      map((event: any) => {
        return event;
      }),
      catchError((err: any) => {
        return EMPTY;
      })
    );
  } else {
    const loadingService = inject(LoadingService);
    const router = inject(Router);
    const matDialog = inject(MatDialog);
    let errorDialog: any;
    let loadingRef: any;
    // Use setTimeout to ensure DOM is ready
    setTimeout(() => {
      loadingRef = loadingService.open();
    }, 0);
    return next(req).pipe(
      map((event: any) => {
        setTimeout(() => {
          if (loadingRef) {
            loadingRef.close();
          }
        }, 1);
        if (event instanceof HttpResponse && event.body?.message) {
          const tokenExpired = event.body.message.endsWith('-10300') ||
            event.body.message.endsWith('-10301') ||
            event.body.message.endsWith('-10302') ||
            event.body.message.endsWith('-10303') ||
            event.body.message.endsWith('-10308');
          if (tokenExpired) {
            router.navigate([RouteUtil.COMMON_MODULE, RouteUtil.SIGN_IN_COMPONENT], {queryParams: {redirectUrl: WindowUtil.getLinkAddress()}}).then();
          }
        }
        return event;
      }),
      catchError((err: any) => {
        setTimeout(() => {
          if (loadingRef) {
            loadingRef.close();
          }
        }, 1);
        switch (err.status) {
          case 429:
            TooManyRequestComponent.URL = err.url;
            if (!errorDialog) {
              const tooManyRequestOptions = new TooManyRequestOptions();
              tooManyRequestOptions.onResolved = () => errorDialog = undefined;
              errorDialog = matDialog.open(TooManyRequestComponent, {
                height: 'auto',
                width: '100%'
              });
              errorDialog.componentInstance.accessGroupsOptions = tooManyRequestOptions;
            }
            break;
          case 0:
            MaintenanceComponent.URL = err.url;
            if (!errorDialog) {
              const maintenanceOptions = new MaintenanceOptions();
              maintenanceOptions.onResolved = () => errorDialog = undefined;
              errorDialog = matDialog.open(MaintenanceComponent, {
                height: 'auto',
                width: '100%'
              });
              errorDialog.componentInstance.accessGroupsOptions = maintenanceOptions;
            }
            break;
        }
        return EMPTY;
      })
    );
  }
};
